import React, { Component } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { connect } from 'react-redux';
import { HashRouter, Route } from 'react-router-dom';
import PT from 'prop-types';
import _ from 'lodash';

import { dataLayerEvents, tracker } from 'common/utils';
import { Loader, Responsive } from 'common/components';
import { ROOT_ROUTE, PODCAST_ROUTE } from 'client/constants';
import * as actions from 'client/actions';
import { Header, RouterSwitch } from 'client/components/common';
import Main from 'client/components/pages/Main';
import Podcast from 'client/components/pages/Podcast';

import * as css from './App.scss';

class App extends Component {
	static propTypes = {
		items: PT.shape({}).isRequired,
		init: PT.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			isStarted: false,
		};

		tracker.init('UA-5536870-34');
	}

	async componentDidMount() {
		await this.props.init();

		this.setState({ isStarted: true });
		this.removeRootPreloader();

		dataLayerEvents.pageView('#/', '​​ראשי – תחנת מוח');
	}

	removeRootPreloader = () => {
		const preloadingScreen = document.querySelector('.preloading-screen');

		if (preloadingScreen) {
			preloadingScreen.addEventListener('transitionend', e => {
				if (e.target === preloadingScreen) {
					document.body.removeChild(preloadingScreen);
				}
			});
			preloadingScreen.style.opacity = 0;
		}
	};

	resetScroll = () => {
		if (Responsive.isMatching(Responsive.DESKTOP)) {
			const container = document.querySelector('#scrollingContainer');

			if (container) container.scrollTop = 0;
		}
	};

	onRouterSwitchUpdate = () => {
		this.resetScroll();
	};

	renderLoader = () => <Loader type="ball-grid-pulse" fullScreen />;

	renderRoute = props => {
		const { isStarted } = this.state;

		/* inAnimFreeze - freeze in-animation - for first entering only */
		switch (props.match.path) {
			case ROOT_ROUTE:
				return (
					<TransitionGroup id="scrollingContainer" className={css.pageContainer} appear enter exit>
						<Main key={props.location.pathname} {...props} isStarted={isStarted} />
					</TransitionGroup>
				);

			case PODCAST_ROUTE:
				return (
					<TransitionGroup id="scrollingContainer" className={css.pageContainer} appear enter exit>
						<Podcast
							key={props.location.pathname}
							{...props}
							isStarted={isStarted}
							inAnimFreeze={props.location.state !== undefined}
						/>
					</TransitionGroup>
				);

			default:
				return null;
		}
	};

	renderHeader = routeProps => {
		const { items } = this.props;
		const { match } = routeProps;

		return <Header items={items} path={match.path} isExact={match.isExact} />;
	};

	render() {
		return (
			<HashRouter>
				<React.Fragment>
					<Route render={this.renderHeader} />
					<RouterSwitch onUpdate={this.onRouterSwitchUpdate}>
						<Route exact path={ROOT_ROUTE} render={this.renderRoute} />
						<Route path={PODCAST_ROUTE} render={this.renderRoute} />
					</RouterSwitch>
				</React.Fragment>
			</HashRouter>
		);
	}
}

export default connect(
	state => ({
		items: _.get(state, 'items.data', {}),
		settings: state.settings,
	}),
	dispatch => ({
		init: async () => dispatch(actions.init()),
	})
)(App);
